
export { useTimeFormat } from "/codebuild/output/src3158552546/src/dgbet/src/contexts/timeFormat/index.tsx"